import http from '../../../../api/http'

function retrieveList(paramObj) {
    return http.post('/admin/user/retrieveAllPagingForUserPicker', {
        pageNumber: paramObj.pageNo || 0,
        size: paramObj.size || 20,
        searchInput: paramObj.searchInput || ''
    })
}

function retrieveListByUserGb(paramObj) {
    return http.post('/admin/user/retrieveUserGbPagingForUserPicker', {
        pageNumber: paramObj.pageNo || 0,
        userGb: paramObj.userGb || 'STUDENT', // STUDENT, TEACHER, ...
        size: paramObj.size || 20,
        searchInput: paramObj.searchInput || ''
    })
}

function retrieveAllUsers(paramObj) {
    return http.post('/admin/user/retrieveAllUsers', {
        pageNumber: paramObj.pageNo || 0,
        userGbList: paramObj.userGbList || [],
        size: paramObj.size || 30,
        searchCorpMasterYn: paramObj.searchCorpMasterYn || "N",
        searchType: paramObj.searchType || "",
        searchInput: paramObj.searchInput || "",
        searchDurationGb: paramObj.searchDurationGb || "L",
        startYmd: paramObj.startYmd || "",
        endYmd:paramObj.endYmd ||  "",
        orderProperty: paramObj.orderProperty ||  "",
        orderDirection: paramObj.orderDirection ||  "",
    })
}

function retrievePartnerAdminPagingByPartnerId(paramObj) {
    return http.post('/admin/user/retrievePartnerAdminPagingByPartnerId', paramObj)
}

function retrieveUser(userId) {
    return http.post('/admin/user/retrieve', {
        userId
    })
}

function updateCorpMasterYn({userId, corpMasterYn}) {
    return http.post('/admin/user/updateCorpMasterYn', {
        userId,
        corpMasterYn
    })
}

function retrieveUserMyPage(paramObj) {
    return http.get(`/admin/user/retrieveMypage?userId=${paramObj.userId}&propId=${paramObj.propId}&hidden=${paramObj.hidden}`)
}

function retrieveUserLectureMypage(userId, lectId, regDt) {
    return http.get(`/admin/user/retrieveUserLectureMypage?userId=${userId}&lectId=${lectId}&regDt=${regDt}`)
}

function deleteUser(userId) {
    return http.post('/admin/user/withdrawUser', {
        userId
    })
}


function retrieveUserLectureList(userId) {
    return http.get(`/admin/user/retrieveUserLectureList?userId=${userId}`)
}


function retrieveUserLectureListByCreateId(userId) {
    return http.get(`/admin/user/retrieveUserLectureListByCreateId?userId=${userId}`)
}


function downloadAllUsers(paramObj) {
    return http.post('/admin/user/downloadAllUsers', {
        pageNumber: paramObj.pageNo || 0,
        userGbList: paramObj.userGbList || [],
        size: paramObj.size || 30,
        searchType: paramObj.searchType || "",
        searchInput: paramObj.searchInput || "",
        searchDurationGb: paramObj.searchDurationGb || "L",
        startYmd: paramObj.startYmd || "",
        endYmd:paramObj.endYmd ||  ""
    }, {
        responseType: 'blob',
    })
}

function sendEmailAllUsers(paramObj) {
    return http.post('/admin/user/sendEmailAllUsers', {
        pageNumber: paramObj.pageNo || 0,
        userGbList: paramObj.userGbList || [],
        size: paramObj.size || 30,
        searchType: paramObj.searchType || "",
        searchInput: paramObj.searchInput || "",
        searchDurationGb: paramObj.searchDurationGb || "L",
        startYmd: paramObj.startYmd || "",
        endYmd:paramObj.endYmd ||  ""
    })
}

function retrieveAdminDetail(userId) {
    return http.get(`/admin/user/retrieveUserForAdmin?userId=${userId}`)
}

function createAdminAccount(paramObj) {
    return http.post('/admin/user/signupForAdmin', paramObj)
}

function updateAdminAccount(paramObj) {
    return http.post('/admin/user/updateForAdmin', paramObj)
}

function deleteAdminAccount(userId) {
    return http.post('/admin/user/withdrawForAdmin', {
        userId
    })
}

function retrieveAllUserGbHistory(paramObj) {
    return http.post('/admin/user/retrieveAllUserGbHistory', paramObj)
}

// 온라인 특별채용관 - 학생/취업준비생
function retrieveAllEntryUserPaging(paramObj) {
    return http.post('/admin/ojf/entry/retrieveAllEntryUserPaging', paramObj)
}

// 온라인 특별채용관 - 재직자/기업
function retrieveAllRecruitmentHallByUserIdPaging(paramObj) {
    return http.post('/admin/ojf/recruitmentHall/retrieveAllRecruitmentHallByUserIdPaging', paramObj)
}

function retrieveOjfResumeListAdminPaging(paramObj) {
    return http.post('/admin/ojf/ojfResume/retrieveOjfResumeListAdminPaging', paramObj)
}

function retrieveInterestHallEntryListAdminPaging(paramObj) {
    return http.post('/admin/ojf/interestHallEntry/retrieveInterestHallEntryListAdminPaging', paramObj)
}

function retrieveInterestJobNoticeListAdminPaging(paramObj) {
    return http.post('/admin/ojf/interestJobNotice/retrieveInterestJobNoticeListAdminPaging', paramObj)
}

function retrieveInterviewProposalEntryListAdminPaging(paramObj) {
    return http.post('/admin/ojf/interviewProposalEntry/retrieveInterviewProposalEntryListAdminPaging', paramObj)
}

// 온라인 특별채용관 참가 신청 정보 수정
function updateAdminEntry(paramObj) {
    return http.post('/admin/ojf/entry/updateAdminEntry', paramObj)
}

// 온라인 특별채용관 참가 신청 상태 수정
function updateEntryJoinStateByUserId(paramObj) {
    return http.post('/admin/ojf/entry/updateEntryJoinStateByUserId', paramObj)
}

// 관심기업(3)의 채용공고 리스트
function retrieveJobNoticeListAdminPaging(paramObj) {
    return http.post('/admin/ojf/jobNotice/retrieveJobNoticeListAdminPaging', paramObj)
}

export default {
    retrieveList,
    retrieveListByUserGb,
    retrieveAllUsers,
    retrievePartnerAdminPagingByPartnerId,
    retrieveUser,
    updateCorpMasterYn,
    retrieveUserMyPage,
    retrieveUserLectureMypage,
    deleteUser,
    retrieveUserLectureList,
    retrieveUserLectureListByCreateId,
    downloadAllUsers,
    sendEmailAllUsers,
    retrieveAdminDetail,
    createAdminAccount,
    updateAdminAccount,
    deleteAdminAccount,
    retrieveAllUserGbHistory,
    retrieveAllEntryUserPaging,
    retrieveAllRecruitmentHallByUserIdPaging,
    retrieveOjfResumeListAdminPaging,
    retrieveInterestHallEntryListAdminPaging,
    retrieveInterestJobNoticeListAdminPaging,
    retrieveInterviewProposalEntryListAdminPaging,
    updateAdminEntry,
    updateEntryJoinStateByUserId,
    retrieveJobNoticeListAdminPaging
}